export enum PrequalificationLevelSelections {
  LevelOne = 'LevelOne',
  None = 'None',
}
